import { useContactContext } from "@/contexts/contact";
import { useMemo } from "react";
import { useSchema } from "@/contexts/contact";
export function useCombinedUserData(currentFormData) {
    var _a;
    const { userData: loggedInUserData, userCookieData } = useContactContext();
    const schema = (_a = useSchema()) === null || _a === void 0 ? void 0 : _a.shape;
    const requiredFields = useMemo(() => schema
        ? Object.entries(schema)
            .filter(([, field]) => !field.isOptional())
            .map(([key]) => key)
        : [], [schema]);
    return useMemo(() => {
        var _a, _b;
        const keys = new Set([
            ...Object.keys(currentFormData !== null && currentFormData !== void 0 ? currentFormData : {}),
            ...Object.keys(loggedInUserData !== null && loggedInUserData !== void 0 ? loggedInUserData : {}),
            ...Object.keys(userCookieData !== null && userCookieData !== void 0 ? userCookieData : {}),
        ]);
        const result = {};
        const isPresent = (value) => value !== null &&
            value !== undefined &&
            (typeof value !== "string" || value.trim() !== "");
        for (const key of keys) {
            const currentValue = currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData[key];
            const loggedInValue = loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData[key];
            const cookieValue = userCookieData === null || userCookieData === void 0 ? void 0 : userCookieData[key];
            const isRequired = requiredFields.includes(key);
            if (currentFormData && key in currentFormData) {
                if (currentValue === "" && isRequired) {
                    result[key] = (_a = [loggedInValue, cookieValue].find(isPresent)) !== null && _a !== void 0 ? _a : "";
                }
                else {
                    result[key] = currentValue !== null && currentValue !== void 0 ? currentValue : "";
                }
            }
            else {
                result[key] =
                    (_b = [loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData[key], userCookieData === null || userCookieData === void 0 ? void 0 : userCookieData[key]].find(isPresent)) !== null && _b !== void 0 ? _b : "";
            }
        }
        return result;
    }, [currentFormData, loggedInUserData, userCookieData, requiredFields]);
}
